export default async () => {

    const grids = document.querySelectorAll('[data-gallery-grid]');
    const sliders = document.querySelectorAll('[data-gallery-slider]');
    const carousels = document.querySelectorAll('[data-gallery-carousel]');
    const images = document.querySelectorAll('[data-gallery-popup]');

    if (!grids.length && !sliders.length && !carousels.length && !images.length) {
        return;
    }

    const [
        { default: Flickity },
        { default: Masonry },
        { default: GLightbox },
    ] = await Promise.all([
        import(/* webpackChunkName: "gallery" */ 'flickity'),
        import(/* webpackChunkName: "gallery" */ 'masonry-layout'),
        import(/* webpackChunkName: "gallery" */ 'glightbox'),
        import(/* webpackChunkName: "gallery" */ 'flickity-fullscreen'),
        import(/* webpackChunkName: "gallery" */ 'flickity-imagesloaded'),
    ]);

    for (const grid of grids) {
        const masonry = new Masonry( grid, {
            itemSelector: '.image-gallery__grid__item'
        });
    }

    for (const slider of sliders) {
        const flkty = new Flickity(slider, {
            cellAlign: 'left',
            imagesLoaded: true,
            wrapAround: true,
            freeScroll: false,
            freeScrollFriction: 0.03,
            pageDots: false,
            prevNextButtons: true // slider.children.length > 10
        });
    }

    for (const carousel of carousels) {
        const flkty = new Flickity(carousel, {
            cellAlign: 'left',
            imagesLoaded: true,
            wrapAround: true,
            freeScroll: true,
            freeScrollFriction: 0.03,
            //pageDots: carousel.children.length <= 10,
            pageDots: false,
            prevNextButtons: true, // slider.children.length > 10
            //groupCells: true,
            autoPlay: 2000,
        });
    }

    if (images.length) {
        GLightbox({
            selector: '[data-gallery-popup]',
        });
    }

}
